import {Model} from 'vue-mc';
import * as dateMethods from "@/helpers/date-methods";

export class BitacoraArchivoModel extends Model{
  // Default attributes that define the "empty" state.
  defaults() {
    return {
        comercio : ""
      , nombreArchivo : ""
      , fecha : dateMethods.getDate()
      , tipoArchivo: ""
    }
  }

  // Attribute mutations.
  mutations() {
    return {
        comercio:comercio=>comercio
        ,nombreArchivo:nombreArchivo=>nombreArchivo
        ,fecha:fecha=>fecha
        ,tipoArchivo:tipoArchivo=>tipoArchivo
    }
  }

  // Attribute validation
  validation() {
    return {
    }
  }

  // Model Options
  options() {
    return {
      validateOnSave     : false
      , validateOnChange   : false 
      , validateRecursively: false
    }
  }

  // Route configuration
  /*routes() {
    return {
      fetch: '/task/{id}'
    }
  }*/

}


// WEBPACK FOOTER //
// ./src/models/bitacoras/bitacora-archivo.js